import React from "react";

function SvgIcMapPoi041(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M24 21.331V16.71a11.23 11.23 0 011.709 1.058l.29.232v3.335L26.667 24h-3.333L24 21.331V16.71zM16 20c2.209 0 4 .448 4 1 0 .553-1.791 1-4 1s-4-.447-4-1c0-.552 1.791-1 4-1zm0-5c2.018 0 3.918.313 5.588.863l.412.143v3.14C20.408 18.434 18.306 18 16 18c-2.162 0-4.144.381-5.696 1.016l-.304.13v-3.14C11.766 15.367 13.813 15 16 15zm0-9l12 7-2 3-.02-.012A18.081 18.081 0 0016 13a18.074 18.074 0 00-10 3l-2-3 12-7z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi041;
